export default {
    LOAD_ORDER_OF_SERVICE(state, order_of_service) {
        state.items = order_of_service;
    }
}